import React from 'react';
import './index.scss';
import App from './main/view/App';
import reportWebVitals from './reportWebVitals';
import getAppContainer from "./main/core/getAppContainer";
import { BrowserRouter } from "react-router-dom";


import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    // <React.StrictMode>
        <BrowserRouter>
            <App appContainer={ getAppContainer() }/>
        </BrowserRouter>
    // </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
